import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { RAW_CACHE } from './variant'
import './styles.css'

// Register Service Worker for aggressive image caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then(() => navigator.serviceWorker.ready)
      .then((reg) => {
        // The static SW can't see build-time env — hand it the API base so
        // it can store images readable (unpadded) via the /api/img proxy.
        // The RAW_CACHE variant sends an empty base: the SW then falls
        // back to plain no-cors caching (raw opaque blocks, unmanaged).
        reg.active?.postMessage({
          type: 'config',
          apiBase: RAW_CACHE ? '' : (import.meta.env.VITE_API_BASE ?? ''),
        })
      })
      .catch(() => { /* non-fatal — app works without SW */ })
  })
}

// Ask the browser not to evict IndexedDB / Cache Storage under disk
// pressure — the cached posts + image bytes are the whole point of this
// app. Browsers may deny (returns false); that's non-fatal.
void navigator.storage?.persist?.().catch(() => {})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
